import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_DIAG_RECORDS_REQUEST: '',
  GET_DIAG_RECORDS_SUCCESS: '',
  GET_DIAG_RECORDS_FAILURE: '',

};

types = setStoreTypeValues(types, 'authDiagRecords');

export default types;
